import React, { useState } from "react";
import "../App.css"
import { Link } from "react-scroll";
import About from "./HOME/About/About";
import BurgerBody from "./HOME/BurgerBody/BurgerBody";
import Contact from "./HOME/Contact/Contact";
import FirstPage from "./HOME/First-page/FirstPage";
import Burger from "./HOME/HamburgerMenu/Burger";
import Skills from "./HOME/Skills/Skills";


const Home = () => {


  const [visible, setVisible] = useState(true);

  const VisibleHandler = () => {
    if (!visible) setVisible(true);
    else setVisible(false);
  };

  return (
    <>
      <div className="hamburger">
        <Burger onVisibility={VisibleHandler} />
      </div>

      {/* Hamburger Body! */}
      {!visible && (
        <div className="hamburger_body">
          <BurgerBody />
        </div>
      )}

      <div className="App">
        <div className="top_banner">
          <Link to="home" >
            <nav className="nav_btn hme">Home</nav>
          </Link>
          <Link to="about" >
            <nav className="nav_btn abt">About</nav>
          </Link>
          <Link to="skills" >
            <nav className="nav_btn skil">Skills</nav>
          </Link>
          <Link to="contact" >
            <nav className="nav_btn cntct">Contact</nav>
          </Link>
        </div>
        <FirstPage />
        <About />
        <Skills />
        <Contact />
      </div>
    </>
  );
};

export default Home;
